import React, { useState } from "react";
import styled from "styled-components";
import { formatRelative } from "date-fns";
import { decode } from "he";
import RatingStars from "./RatingStars";
import { Body, BodyStyles, Header4, Header6, ProximaNova } from "./typography";
import { Colors } from "./styles/Colors";
import Breakpoints from "./styles/Breakpoints";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  text-align: left;

  margin: 40px auto;

  max-width: 900px;

  @media ${Breakpoints.tablet} {
   flex-direction: row;
  }

  ${Header4} {
    display: block;
    margin-bottom: 20px;

    color: ${Colors.darkGrey};

    @media ${Breakpoints.tablet} {
      flex: 0 0 200px;
    }
  }

  > div {
    @media ${Breakpoints.tablet} {
      margin-left: 20px;
    }

    ${Header6} {
      color: ${Colors.grey};
      margin: 0 0 8px;
    }

    p {
      color: ${Colors.greyLight};
    }

    span {
      ${BodyStyles}

      display: flex;
      align-items: center;
      margin-top: 24px;

      font-size: 14px;
      color: ${Colors.greyLight};

      div {
        margin: 0;
      }
    }
  }
`;

const SeeMoreLink = styled.button`
  ${BodyStyles}

  background: 0;
  border: 0;

  color: ${Colors.hunter};

  cursor: pointer;
`;

export default function Review({ review }) {
  const [expanded, setExpanded] = useState(false);

  const body = decode(review.content);

  const TruncatedBody = (
    <>
      {body.substring(0, 400)}...{" "}
      <SeeMoreLink onClick={() => setExpanded(true)}>See More</SeeMoreLink>
    </>
  );

  return (
    <Wrapper>
      <Header4>{review.name}</Header4>
      <div>
        <Header6>{review.title}</Header6>
        <Body>{expanded || body.length < 400 ? body : TruncatedBody}</Body>
        <span>
          <RatingStars score={review.score} />
          {formatRelative(new Date(review.createdAt), new Date())}
        </span>
      </div>
    </Wrapper>
  );
}
